module.exports = __webpack_public_path__ + "img/sx_04.9dbbee10.jpg";